var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "currentColor",
    viewBox: "0 0 105 105"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "m45.39 36 22.608 16.608L45.39 69.215z"
  })));
};
export { SvgPlay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIGNvbG9yPSJjdXJyZW50Q29sb3IiIHZpZXdCb3g9IjAgMCAxMDUgMTA1Ij4KICA8Y2lyY2xlIGN4PSI1Mi41IiBjeT0iNTIuNSIgcj0iNTIuNSIgZmlsbD0iI2ZmZiIvPgogIDxwYXRoIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMyIgZD0ibTQ1LjM5IDM2IDIyLjYwOCAxNi42MDhMNDUuMzkgNjkuMjE1eiIvPgo8L3N2Zz4K";